var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark-mode-btn",class:_vm.darkMode ? 'active' : '',on:{"click":_vm.btnOnClick}})}
var staticRenderFns = []

export { render, staticRenderFns }